import React, { useState, useEffect } from 'react';
import './Settings.scss';
import ReactLoading from 'react-loading';
import { fireauth } from './../config/firebase.config';
import TextField from '@material-ui/core/TextField';

const Login = () => {


    const [loading, setloading] = useState(true)
    let email = "";
    let password = "";

    useEffect(() => {
        setloading(false)
    }, []);


    const singIn = async e => {
        e.preventDefault();
        if (email.length * password.length === 0)
            return false
        try {
            let response = await fireauth.signInWithEmailAndPassword(email, password)
        } catch (error) {
            return false
        }

    }
    if (loading)
        return (<div className="root"><ReactLoading type="spin" color="#0e2819" className="ReactLoading" height={150} width={150} /></div>)

    return (<div className="root"><div className="topbanner"><h2>Espace points de retraits</h2></div>
        <div className="login">
            <TextField id="filled-basic1" label="Email de connection" variant="outlined"
                name="email"
                placeholder="admin.sweethé@cestbon.com"
                onChange={(e) => { email = e.target.value }
                }

                InputProps={{
                    startAdornment: <img className="user" src={require('./../img/user.png')} alt="" />
                }}
            />
            <TextField id="filled-basic2" label="Mot de passe" variant="outlined"
                name="password"
                type='password'
                placeholder="**********"
                onChange={(e) => { password = e.target.value }
                }
                InputProps={{
                    startAdornment: <img className="user" src={require('./../img/key.png')} alt="" />
                }}
            />
            <div className="elementor-button-wrapper">
                <a onClick={(e) => {
                    singIn(e);
                }} className="elementor-button-link elementor-button elementor-size-lg" role="button">
                    <span className="elementor-button-content-wrapper">
                        <span className="elementor-button-text">Se connecter</span>
                    </span>
                </a>
            </div>
        </div>
    </div>)


}

export default Login;